const myProfileRoot = '/auth/my-profile'
const changePasswordRoot = '/auth/change-password'
const multiFactorAuthRoot = '/auth/multi-factor-auth'
const securityQuestionRoot = '/auth/security-question'
const activateAccountRoot = '/unauth/activate-account'
const faqsRoot = '/unauth/faqs'
const faqsAuthRoot = '/auth/faqsauth'
const passwordResetRoot = '/unauth/password-reset'
const passwordExpiredRoot = '/unauth/password-expired'
const emailVerification = '/unauth/email-verification'
const updateSuccess = '/unauth/update-success'
const verifyPhone = '/auth/verify-phone'
const phoneSuccess = '/auth/phone-success'
const verifyEmail = '/auth/verify-email'
const emailSuccess = '/auth/email-success'
const emailUpdateSuccess = '/auth/email-update-success'
const authAppSuccess = '/auth/auth-app-success'

export {
  myProfileRoot,
  changePasswordRoot,
  multiFactorAuthRoot,
  securityQuestionRoot,
  activateAccountRoot,
  faqsRoot,
  faqsAuthRoot,
  passwordResetRoot,
  passwordExpiredRoot,
  emailVerification,
  updateSuccess,
  verifyPhone,
  phoneSuccess,
  verifyEmail,
  emailSuccess,
  emailUpdateSuccess,
  authAppSuccess
}